import { render, staticRenderFns } from "./CreateArticleCategory.vue?vue&type=template&id=c9b0cae2&"
import script from "./CreateArticleCategory.vue?vue&type=script&lang=js&"
export * from "./CreateArticleCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports